module.exports = __webpack_public_path__ + "img/grenada.f0cee3f8.svg";